function initializePayJustNowProduct(container) {
  var root = container || document;
  var payJustNowContainer = root.querySelector('#pjn-product-container');

  if (!payJustNowContainer || payJustNowContainer.dataset.pjnInitialized === 'true') return;

  var price = parseInt(payJustNowContainer.getAttribute('data-pjn-price'), 10);

  if (Number.isNaN(price)) return;

  function renderPayJustNow() {
    if (typeof window.setPJNProductAmounts !== 'function') return;

    window.setPJNProductAmounts(price, 3);
    payJustNowContainer.dataset.pjnInitialized = 'true';
  }

  if (typeof window.setPJNProductAmounts === 'function') {
    renderPayJustNow();
    return;
  }

  if (window.__pjnProductScriptLoading) {
    document.addEventListener('payjustnow:loaded', renderPayJustNow, { once: true });
    return;
  }

  window.__pjnProductScriptLoading = true;

  var script = document.createElement('script');
  script.src = 'https://embed.payjustnow.com/product/js/product.js';
  script.async = true;
  script.onload = function () {
    window.__pjnProductScriptLoading = false;
    document.dispatchEvent(new Event('payjustnow:loaded'));
    renderPayJustNow();
  };
  script.onerror = function () {
    window.__pjnProductScriptLoading = false;
  };

  document.head.appendChild(script);
}

document.addEventListener('DOMContentLoaded', function () {
  initializePayJustNowProduct(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initializePayJustNowProduct(event.target);
});
